var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-40 -40 193.774 229.062",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "enroll_svg__icon",
    d: "M102 189c-14.5-2.25-26.9-11-33.7-23.8-.917-1.72-1.96-3.92-2.32-4.89l-.648-1.76h-65l.168-17.1c.156-15.8.23-17.4.966-20.7 4.13-18.7 18-33.1 36.8-38.4 8.99-2.51 20.4-2.42 29.5.237 8.99 2.62 16.3 7.04 23.1 14l3.7 3.76 3.33-.871c4.71-1.23 13-1.54 18.1-.677 23.6 4 40.2 25.6 37.9 49.1-1.41 14.3-8.57 26.2-20.6 34.1-7.57 4.98-15.6 7.27-25 7.18-2.92-.028-5.72-.115-6.23-.194zm16-11.4c20.4-6.12 31-27.9 22.9-47.5-3.23-7.79-10-14.8-17.9-18.4-5.18-2.39-7.85-2.94-14.5-2.94-5.05 0-6.34.123-8.84.84-8.67 2.49-15.8 7.65-20.6 15-11.4 17.3-5.22 40.8 13.3 50.3 6.1 3.12 9.83 3.95 17 3.77 4.47-.109 5.9-.293 8.61-1.1zm-14.5-18.9v-9.8H85.02v-11.84h18.48v-19.6h11.46v19.6h18.5l-.102 5.82-.102 5.82-9.15.099-9.15.099v19.58h-11.46v-9.8zm-56-82.2C26 73.59 11.1 53.4 14.6 32 17.04 16.9 28 4.9 42.9.8c2.78-.759 3.93-.855 9.98-.832 6.31.024 7.1.102 10.2 1.02 18.2 5.45 29.6 22.2 27.9 40.9-1.87 19.9-18.7 35-38.6 34.7-2.06-.031-4.24-.123-4.85-.206z"
  })));
}

export default SvgEnroll;